const config = Object.freeze({
  fallbackLocale: "EN-GB",
  localStoragePrefix: "textmanager.0551.prefs",
});

export default config;
